export function isFilled(value) {
  const val = value && value.replace(/^\s+|\s+$/g, '');
  return !!val;
}

export function isEmpty(value) {
  return !isFilled(value);
}

// TO DO :: integrate lodash like method
export function isEqual(value1, value2) {
  return JSON.stringify(value1) === JSON.stringify(value2);
}

export function isValidUrl(value) {
  const validUrlRegex = global.JotForm.validationRegexes.url;
  return isFilled(value) && validUrlRegex.test(value);
}
